import { Injectable } from '@angular/core';
import { Subscriber } from 'rxjs';
import { globals } from '../globals';
import { UploadService } from './upload.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ArquivoResumoPedidoService {

  constructor(
    private uploadService: UploadService,
    private http: HttpClient
  ) { }

  consultaExisteArquivoResumo(monitor) {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoResumoPedido/ExisteArquivoResumoPedido', {
      params: new HttpParams().set('monitor', monitor)
    });
  }

  enviarArquivoPorMonitor(formData) {
    return this.uploadService.upload(formData, globals.apiUrl + '/api/ArquivoResumoPedido/SalvarArquivoResumoPedido');
  }

  baixarArquivoPorMonitor(monitor) {
    return this.http.get(globals.apiUrl + '/api/ArquivoResumoPedido/BaixarArquivoResumoPedido', {
      responseType: 'blob',
      params: new HttpParams().set('monitor', monitor)
    });
  }

  excluirArquivoPorMonitor(monitor) {
    return this.http.get(globals.apiUrl + '/api/ArquivoResumoPedido/ExcluirArquivoResumoPedido', {
      params: new HttpParams().set('monitor', monitor)
    });
  }

  public consultarVariaveis(ocultarValores) {
    return this.http.get<any>(globals.apiUrl + '/api/ArquivoResumoPedido/BuscarVariaveis', {
      params: new HttpParams().set('ocultarValores', ocultarValores)
    });
  }
}
